(function () {

    'use strict';

    function pxSelectDocumentSources() {
        return {
            restrict: 'EA',
            scope: {
                availableItems: '=',
                selectedItems: '=',
                onDone: '&',
                onCancel: '&'
            },
            templateUrl: 'app/components/settings/cloudStorage/selectDocumentSources/selectDocumentSources.template.html',
            link: function (scope) {

                scope.documentSourceCaptions = {
                    PRINT_ANYWHERE: 'PrintAnywhere',
                    PRINT_LATER: 'PrintLater',
                    VIA_THE_CLOUD: 'ViaTheCloud',
                    CHROME_PRINT: 'ChromePrint',
                    MOBILE_PRINT: 'MobilePrint',
                    PRINT_CAPTURE: 'PrinterCapture',
                    MOBILE_CAPTURE: 'MobileCapture'
                };

                scope.items = scope.availableItems.map(item => {
                    return { name: item, selected: scope.selectedItems.includes(item) };
                });

                scope.selectItem = function (item) {
                    item.selected = true;
                };

                scope.deselectItem = function (item) {
                    item.selected = false;
                };

                scope.isNoDocumentSourceSelected = function () {
                    return !scope.items.some(item => item.selected);
                };

                scope.onDoneButtonClick = function () {
                    scope.onDone({ selectedItems: scope.items.filter(item => item.selected).map(item => item.name) });
                };

                scope.onCloseButtonClick = function () {
                    scope.onCancel();
                };

                scope.onOutsideClick = function () {
                    // scope.onCancel();
                };

            }
        };
    }

    pxSelectDocumentSources.$inject = [];

    angular
        .module('printix-admin')
        .directive('pxSelectDocumentSources', pxSelectDocumentSources);

})();
